<script setup lang="ts">
defineProps<{
  title: string
  description: string
}>()
</script>

<template>
  <div>
    <Heading size="big" class="mb-2">{{ title }}</Heading>
    <Paragraph>{{ description }}</Paragraph>
  </div>
</template>
